module.exports = __webpack_public_path__ + "static/pp_numer_telefonu-76b82642a083e6f7616e6a52a4aab7d7.gif";